import React from 'react';
import LoginDumb from './LoginDumb';
import withRequest from 'hoc/withRequest';
import { withRouter } from 'react-router-dom';
import { useUser } from 'components/hooks';
import { Alert } from 'components/common';


const LoginSmart = () => {
  const { error, isLoaded, signIn, cleanUpMessage } = useUser();

  const handleFormSubmit = (data) => {
    signIn(
      {
        body: {
          username: data.username,
          pass: data.password
        }
      },
      data.rememberMe
    )
  }

  return (
    <>
      <LoginDumb
        isLoaded={isLoaded.auth}
        handleFormSubmit={handleFormSubmit}
      />
      <Alert
        severity="error"
        handleClose={() => cleanUpMessage()}
        open={error.auth}
        message={error.auth}
      />
    </>
  )
}

export default withRequest(withRouter(LoginSmart));
